module.exports = {
  // catalogUrl: "http://localhost:9000/mdl-metadata/metadata/catalog.stac.json",  // LOCAL
  // catalogUrl:
  //   "https://s3.waw3-1.cloudferro.com/mdl-metadata/metadata/catalog.stac.json", // MDS
  catalogUrl:
    "https://arco.datastores.ecmwf.int/cadl-metadata/metadata/catalog.stac.json", // CADL
  catalogTitle: "CADL STAC Browser",
  catalogImage: null,
  allowExternalAccess: false, // Must be true if catalogUrl is not given
  allowedDomains: [],
  detectLocaleFromBrowser: true,
  storeLocale: true,
  locale: "en",
  fallbackLocale: "en",
  supportedLocales: [
    "de",
    "ar",
    //      "de-CH",
    "es",
    "en",
    //      "en-GB",
    //      "en-US",
    "fr",
    //      "fr-CA",
    //      "fr-CH",
    "it",
    //      "it-CH",
    "ro",
    "ja",
    "pt",
    //      "pt-BR"
    "id",
    "pl",
  ],
  apiCatalogPriority: null,
  useTileLayerAsFallback: false,
  displayGeoTiffByDefault: false,
  displayPreview: true,
  displayOverview: true,
  buildTileUrlTemplate: null,
  getMapSourceOptions: null,
  pathPrefix: "/",
  historyMode: "history",
  cardViewMode: "cards",
  cardViewSort: "asc",
  showKeywordsInItemCards: false,
  showKeywordsInCatalogCards: false,
  showThumbnailsAsAssets: false,
  searchResultsPerPage: null,
  itemsPerPage: null,
  collectionsPerPage: null,
  maxEntriesPerPage: 1000,
  defaultThumbnailSize: null,
  crossOriginMedia: null,
  requestHeaders: {},
  requestQueryParameters: {},
  socialSharing: ["email", "bsky", "mastodon"],
  preprocessSTAC: null,
  authConfig: null,
  crs: {},
};
